// import React, { useEffect, useState } from "react";
// import { URL } from "../../../../config";
// import { useOutletContext, useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import {
//   FaGift,
//   FaCopy,
//   FaCheck,
//   FaUsers,
//   FaCheckDouble,
//   FaCoins,
//   FaLightbulb,
//   FaHistory,
//   FaTicketAlt,
//   FaArrowLeft,
// } from "react-icons/fa";
// import "./ServitorReferralRewards.css";

// const ServitorReferralRewards = () => {
//   const { servitor } = useOutletContext();
//   const { t } = useTranslation("servitor");
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(true);
//   const [summary, setSummary] = useState(null);
//   const [copied, setCopied] = useState(false);
//   const [applyCode, setApplyCode] = useState("");
//   const [applying, setApplying] = useState(false);
//   const [applyMsg, setApplyMsg] = useState("");
//   const [error, setError] = useState(null);
//   const [showApplyModal, setShowApplyModal] = useState(false);

//   const token = localStorage.getItem("token");

//   // A safe fetch helper which returns parsed json or throws
//   async function safeFetch(url, options = {}) {
//     const res = await fetch(url, options);
//     const text = await res.text();
//     let data;
//     try {
//       data = text ? JSON.parse(text) : {};
//     } catch {
//       data = { raw: text };
//     }
//     if (!res.ok) {
//       const message = data?.message || data?.error || res.statusText || "Fetch error";
//       const err = new Error(message);
//       err.status = res.status;
//       err.data = data;
//       throw err;
//     }
//     return data;
//   }

//   // Fetch summary — try primary path then fallback path if 404
//   const fetchSummary = async () => {
//     if (!servitor || !servitor.Id) return;

//     setLoading(true);
//     setError(null);

//     const headers = token ? { Authorization: `Bearer ${token}` } : {};
//     const primary = `${URL}/referrals/servitors/${servitor.Id}/summary`;
//     const fallback = `${URL}/referral/summary/${servitor.Id}`;

//     try {
//       let data;
//       try {
//         data = await safeFetch(primary, { headers });
//       } catch (errPrim) {
//         if (errPrim.status === 404 || errPrim.status === 400) {
//           data = await safeFetch(fallback, { headers });
//         } else {
//           throw errPrim;
//         }
//       }
//       setSummary(data);
//     } catch (err) {
//       console.error("Failed to load referral summary:", err);
//       setError(err.message || "Failed to fetch referral summary");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSummary();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [servitor?.Id]);

//   const copyCode = async () => {
//     if (!summary?.referralCode) return;
//     try {
//       await navigator.clipboard.writeText(summary.referralCode);
//       setCopied(true);
//       setTimeout(() => setCopied(false), 1600);
//     } catch (e) {
//       console.error("Copy failed", e);
//     }
//   };

//   const handleApply = async (e) => {
//     e.preventDefault();
//     if (!applyCode.trim() || !servitor?.Id) return;
//     setApplying(true);
//     setApplyMsg("");
//     setError(null);
//     try {
//       const res = await fetch(`${URL}/referrals/apply`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: token ? `Bearer ${token}` : "",
//         },
//         body: JSON.stringify({ servitorId: servitor.Id, code: applyCode.trim().toUpperCase() }),
//       });

//       const payload = await res.json().catch(() => ({ message: "Invalid JSON response" }));
//       if (!res.ok) {
//         throw new Error(payload?.message || payload?.error || `HTTP ${res.status}`);
//       }

//       setApplyMsg(t("rewards.applySuccess") || "রেফারেল সফলভাবে প্রয়োগ হয়েছে!");
//       setApplyCode("");
//       setTimeout(() => {
//         setShowApplyModal(false);
//         setApplyMsg("");
//       }, 1200);
//       await fetchSummary();
//     } catch (err) {
//       console.error("Apply referral error:", err);
//       setApplyMsg("");
//       setError(err.message || "Failed to apply referral code");
//     } finally {
//       setApplying(false);
//     }
//   };

//   const canApply = !summary?.applicant?.hasApplied && !summary?.applicant?.hasQualifiedRecharge;

//   if (loading) {
//     return (
//       <div className="ref-wrap">
//         <div className="ref-topbar">
//           <button className="ref-back" onClick={() => navigate(-1)}>
//             <FaArrowLeft /> প্রোফাইলে ফিরে যান
//           </button>
//         </div>
//         <div className="ref-loading">
//           <div className="ref-spinner"></div>
//           <p>Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="ref-wrap">
//         <div className="ref-topbar">
//           <button className="ref-back" onClick={() => navigate(-1)}>
//             <FaArrowLeft /> প্রোফাইলে ফিরে যান
//           </button>
//         </div>
//         <div className="ref-error-card">
//           <div className="ref-error-icon">⚠️</div>
//           <div className="ref-error-message">Error: {error}</div>
//           <button className="ref-retry-btn" onClick={fetchSummary}>Retry</button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="ref-wrap">
//       {/* Header */}
//       <div className="ref-header">
//         <h1 className="ref-page-title">
//           {t("rewards.title", { defaultValue: "রেফার করুন ও আয় করুন" })}
//         </h1>
//         <p className="ref-page-subtitle">
//           {t("rewards.subtitle", { defaultValue: "আপনার বন্ধুদের আমন্ত্রণ জানান এবং উভয়ে বোনাস পান!" })}
//         </p>
//       </div>

//       {/* Referral Code Card (compact) */}
//       <div className="ref-code-card ref-compact-card">
//         <div className="ref-code-content">
//           <FaGift className="ref-code-icon" />
//           <h2 className="ref-code-title">আপনার রেফারেল কোড</h2>
//           <p className="ref-code-subtitle">এই কোডটি শেয়ার করুন এবং প্রতিটি সফল রেফারেলে ৫০ টাকা পান</p>

//           <div className="ref-code-display">
//             <span className="ref-code-text">
//               {summary?.referralCode || t("rewards.codeAfterApproval")}
//             </span>
//           </div>

//           <button className="ref-code-copy-btn" onClick={copyCode} disabled={!summary?.referralCode}>
//             {copied ? (<><FaCheck /> কপি হয়েছে</>) : (<><FaCopy /> কোড কপি করুন</>)}
//           </button>
//         </div>
//       </div>

//       {/* Stats (more compact) */}
//       <div className="ref-stats-grid">
//         <div className="ref-stat-card ref-compact-card">
//           <div className="ref-stat-icon-wrapper ref-stat-blue">
//             <FaUsers className="ref-stat-icon" />
//           </div>
//           <div className="ref-stat-value">{summary?.invitedCount || 0}</div>
//           <div className="ref-stat-label">{t("rewards.invited", { defaultValue: "মোট রেফারেল" })}</div>
//         </div>

//         <div className="ref-stat-card ref-compact-card">
//           <div className="ref-stat-icon-wrapper ref-stat-green">
//             <FaCheckDouble className="ref-stat-icon" />
//           </div>
//           <div className="ref-stat-value">{summary?.qualifiedCount || 0}</div>
//           <div className="ref-stat-label">{t("rewards.qualified", { defaultValue: "সফল রেফারেল" })}</div>
//         </div>

//         <div className="ref-stat-card ref-compact-card">
//           <div className="ref-stat-icon-wrapper ref-stat-yellow">
//             <FaCoins className="ref-stat-icon" />
//           </div>
//           <div className="ref-stat-value">{(summary?.totalEarned || 0).toLocaleString()} TK</div>
//           <div className="ref-stat-label">{t("rewards.totalEarned", { defaultValue: "মোট বোনাস" })}</div>
//         </div>
//       </div>

//       {/* How it works (compact) */}
//       <div className="ref-how-card ref-compact-card">
//         <h3 className="ref-section-title">
//           <FaLightbulb className="ref-section-icon" />
//           কিভাবে কাজ করে?
//         </h3>

//         <div className="ref-steps-grid">
//           <div className="ref-step-item">
//             <div className="ref-step-number">1</div>
//             <h4 className="ref-step-title">শেয়ার করুন</h4>
//             <p className="ref-step-desc">{t("rewards.step1", { defaultValue: "আপনার রেফারেল কোড বন্ধুদের সাথে শেয়ার করুন" })}</p>
//           </div>

//           <div className="ref-step-item">
//             <div className="ref-step-number ref-step-number-purple">2</div>
//             <h4 className="ref-step-title">সাইন আপ</h4>
//             <p className="ref-step-desc">{t("rewards.step2", { defaultValue: "আপনার বন্ধু আপনার কোড দিয়ে সাইন আপ করে" })}</p>
//           </div>

//           <div className="ref-step-item">
//             <div className="ref-step-number ref-step-number-green">3</div>
//             <h4 className="ref-step-title">বোনাস পান</h4>
//             <p className="ref-step-desc">{t("rewards.step3", { defaultValue: "উভয়ে ৫০ টাকা করে বোনাস পান" })}</p>
//           </div>
//         </div>
//       </div>

//       {/* Apply Code CTA */}
//       {canApply && (
//         <div className="ref-apply-compact-card ref-compact-card">
//           <div className="ref-apply-compact-content">
//             <FaTicketAlt className="ref-apply-compact-icon" />
//             <div className="ref-apply-compact-text">
//               <h4 className="ref-apply-compact-title">রেফারেল কোড আছে?</h4>
//               <p className="ref-apply-compact-subtitle">কোড প্রয়োগ করে ৫০ টাকা বোনাস পান</p>
//             </div>
//           </div>
//           <button className="ref-apply-compact-btn" onClick={() => setShowApplyModal(true)}>
//             কোড প্রয়োগ করুন
//           </button>
//         </div>
//       )}

//       {/* History */}
//       {summary?.recent && summary.recent.length > 0 && (
//         <div className="ref-history-card ref-compact-card">
//           <h3 className="ref-section-title">
//             <FaHistory className="ref-section-icon" />
//             রেফারেল হিস্টরি
//           </h3>

//           <div className="ref-history-list">
//             {summary.recent.map((r) => {
//               const peer = r.peer;
//               const avatar = peer?.image ? `${URL}/uploads/${peer.image}` : "https://i.pravatar.cc/80?img=15";
//               return (
//                 <div key={r.Id} className="ref-history-item">
//                   <div className="ref-history-left">
//                     <img className="ref-history-avatar" src={avatar} alt={peer?.fullName || "User"} />
//                     <div className="ref-history-info">
//                       <h4 className="ref-history-name">{peer?.fullName || t("rewards.unknown", { defaultValue: "Unknown" })}</h4>
//                       <p className="ref-history-feedback">{r.feedback}</p>
//                       <p className="ref-history-date">{new Date(r.transactionDate).toLocaleDateString("bn-BD")}</p>
//                     </div>
//                   </div>
//                   <div className="ref-history-amount">+{r.netAmount} TK</div>
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       )}

//       {/* Already Applied Notice */}
//       {!canApply && (
//         <div className="ref-already-applied ref-compact-card">
//           <FaCheck className="ref-already-applied-icon" />
//           <div className="ref-already-applied-text">
//             {summary?.applicant?.hasApplied
//               ? t("rewards.alreadyApplied", { defaultValue: "আপনি ইতিমধ্যে একটি রেফারেল কোড প্রয়োগ করেছেন" })
//               : t("rewards.notEligible", { defaultValue: "আপনি ইতিমধ্যে রিচার্জ করেছেন; রেফারেল যোগ্য নয়" })}
//           </div>
//         </div>
//       )}

//       {/* Back button */}
//       <div className="ref-topbar">
//         <button className="ref-back" onClick={() => navigate(-1)}>
//           <FaArrowLeft /> ফিরে যান
//         </button>
//       </div>

//       {/* Apply Code Modal */}
//       {showApplyModal && (
//         <div className="ref-modal-overlay" onClick={() => setShowApplyModal(false)}>
//           <div className="ref-modal-content" onClick={(e) => e.stopPropagation()}>
//             <div className="ref-modal-header">
//               <h2 className="ref-modal-title">
//                 <FaTicketAlt className="ref-modal-title-icon" />
//                 রেফারেল কোড প্রয়োগ করুন
//               </h2>
//               <button className="ref-modal-close" onClick={() => setShowApplyModal(false)}>✕</button>
//             </div>

//             <div className="ref-modal-body">
//               <div className="ref-modal-info-box">
//                 <div className="ref-modal-info-icon"><FaGift /></div>
//                 <div className="ref-modal-info-text">
//                   <h3 className="ref-modal-info-title">বিশেষ অফার!</h3>
//                   <p className="ref-modal-info-desc">রেফারেল কোড প্রয়োগ করুন এবং তাৎক্ষণিক <strong>৫০ টাকা বোনাস</strong> পান!</p>
//                 </div>
//               </div>

//               <form className="ref-modal-form" onSubmit={handleApply}>
//                 <div className="ref-modal-input-group">
//                   <label className="ref-modal-label">রেফারেল কোড লিখুন</label>
//                   <input
//                     type="text"
//                     className="ref-modal-input"
//                     placeholder="যেমন: ARIFUL2025"
//                     value={applyCode}
//                     onChange={(e) => setApplyCode(e.target.value.toUpperCase())}
//                     maxLength={24}
//                     required
//                   />
//                   {error && <div className="ref-modal-error">{error}</div>}
//                   {applyMsg && <div className="ref-modal-success"><FaCheck /> {applyMsg}</div>}
//                 </div>

//                 <button type="submit" className="ref-modal-submit-btn" disabled={applying}>
//                   {applying ? "প্রয়োগ হচ্ছে..." : "কোড প্রয়োগ করুন"}
//                 </button>
//               </form>

//               <div className="ref-modal-terms">
//                 <h4 className="ref-modal-terms-title">শর্তাবলী:</h4>
//                 <ul className="ref-modal-terms-list">
//                   <li><FaCheck className="ref-modal-terms-icon" /><span>প্রতি অ্যাকাউন্টে একবারই প্রয়োগযোগ্য</span></li>
//                   <li><FaCheck className="ref-modal-terms-icon" /><span>বোনাস তাৎক্ষণিক যোগ হবে</span></li>
//                   <li><FaCheck className="ref-modal-terms-icon" /><span>নিজের রেফারেল কোড ব্যবহার করা যাবে না</span></li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ServitorReferralRewards;






import React, { useEffect, useState } from "react";
import { URL } from "../../../../config";
import { useOutletContext, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FaGift,
  FaCopy,
  FaCheck,
  FaUsers,
  FaCheckDouble,
  FaCoins,
  FaLightbulb,
  FaHistory,
  FaTicketAlt,
  FaArrowLeft,
} from "react-icons/fa";
import "./ServitorReferralRewards.css";
import Loader from "../../../../Components/LoaderSpin/Loader";

const ServitorReferralRewards = () => {
  const { servitor } = useOutletContext();
  const { t } = useTranslation("servitor");
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState(null);
  const [copied, setCopied] = useState(false);
  const [applyCode, setApplyCode] = useState("");
  const [applying, setApplying] = useState(false);
  const [applyMsg, setApplyMsg] = useState("");
  const [error, setError] = useState(null);
  const [showApplyModal, setShowApplyModal] = useState(false);

  const token = localStorage.getItem("token");

  async function safeFetch(url, options = {}) {
    const res = await fetch(url, options);
    const text = await res.text();
    let data;
    try {
      data = text ? JSON.parse(text) : {};
    } catch {
      data = { raw: text };
    }
    if (!res.ok) {
      const message = data?.message || data?.error || res.statusText || "Fetch error";
      const err = new Error(message);
      err.status = res.status;
      err.data = data;
      throw err;
    }
    return data;
  }

  const fetchSummary = async () => {
    if (!servitor || !servitor.Id) return;

    setLoading(true);
    setError(null);

    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const primary = `${URL}/referrals/servitors/${servitor.Id}/summary`;
    const fallback = `${URL}/referral/summary/${servitor.Id}`;

    try {
      let data;
      try {
        data = await safeFetch(primary, { headers });
      } catch (errPrim) {
        if (errPrim.status === 404 || errPrim.status === 400) {
          data = await safeFetch(fallback, { headers });
        } else {
          throw errPrim;
        }
      }
      setSummary(data);
    } catch (err) {
      console.error("Failed to load referral summary:", err);
      setError(err.message || t("errors.fetch"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSummary();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [servitor?.Id]);

  const copyCode = async () => {
    if (!summary?.referralCode) return;
    try {
      await navigator.clipboard.writeText(summary.referralCode);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch (e) {
      console.error("Copy failed", e);
    }
  };

  const handleApply = async (e) => {
    e.preventDefault();
    if (!applyCode.trim() || !servitor?.Id) return;
    setApplying(true);
    setApplyMsg("");
    setError(null);
    try {
      const res = await fetch(`${URL}/referrals/apply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token ? `Bearer ${token}` : "",
        },
        body: JSON.stringify({
          servitorId: servitor.Id,
          code: applyCode.trim().toUpperCase(),
        }),
      });

      const payload = await res.json().catch(() => ({ message: "Invalid JSON response" }));
      if (!res.ok) {
        throw new Error(payload?.message || payload?.error || `HTTP ${res.status}`);
      }

      setApplyMsg(t("rewards.applySuccess"));
      setApplyCode("");
      setTimeout(() => {
        setShowApplyModal(false);
        setApplyMsg("");
      }, 1200);
      await fetchSummary();
    } catch (err) {
      console.error("Apply referral error:", err);
      setApplyMsg("");
      setError(err.message || t("errors.apply"));
    } finally {
      setApplying(false);
    }
  };


  const formatLongDMY = (input) => {
  const d = new Date(input);
  if (Number.isNaN(d.getTime())) return String(input ?? "");
  const day = d.getDate();
  const month = d.toLocaleString("en-GB", { month: "long" });
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};

  const canApply =
    !summary?.applicant?.hasApplied && !summary?.applicant?.hasQualifiedRecharge;

  /* Loading */
  if (loading) {
    return (
      <div className="ref-wrap">
        <div className="ref-topbar">
          <button className="ref-back" onClick={() => navigate(-1)}>
            <FaArrowLeft /> {t("commonthing.backToProfile")}
          </button>
        </div>
        <div className="ref-loading" style={{ width: "100%" }}>
          <Loader />
          <p>{t("commonthing.loading")}</p>
        </div>
      </div>
    );
  }

  /* Error */
  if (error) {
    return (
      <div className="ref-wrap">
        <div className="ref-topbar">
          <button className="ref-back" onClick={() => navigate(-1)}>
            <FaArrowLeft /> {t("commonthing.backToProfile")}
          </button>
        </div>
        <div className="ref-error-card">
          <div className="ref-error-icon">⚠️</div>
          <div className="ref-error-message">Error: {error}</div>
          <button className="ref-retry-btn" onClick={fetchSummary}>
            {t("commonthing.retry")}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="ref-wrap">
      {/* Header */}
      <div className="ref-header">
        <h1 className="ref-page-title">{t("rewards.title")}</h1>
        <p className="ref-page-subtitle">{t("rewards.subtitle")}</p>
        
      </div>

      {/* Referral Code Card */}
      <div className="ref-code-card ref-compact-card">
        <div className="ref-code-content">
          <FaGift className="ref-code-icon" />
          <h2 className="ref-code-title">{t("rewards.codeTitle")}</h2>
          <p className="ref-code-subtitle">{t("rewards.codeSubtitle")}</p>

          <div className="ref-code-display">
            <span className="ref-code-text">
              {summary?.referralCode || t("rewards.codeAfterApproval")}
            </span>
          </div>

          <button
            className="ref-code-copy-btn"
            onClick={copyCode}
            disabled={!summary?.referralCode}
          >
            {copied ? (
              <>
                <FaCheck /> {t("rewards.copied")}
              </>
            ) : (
              <>
                <FaCopy /> {t("rewards.copy")}
              </>
            )}
          </button>
        </div>
      </div>

      {/* Stats */}
      <div className="ref-stats-grid">
        <div className="ref-stat-card ref-compact-card">
          <div className="ref-stat-icon-wrapper ref-stat-blue">
            <FaUsers className="ref-stat-icon" />
          </div>
          <div className="ref-stat-value">{summary?.invitedCount || 0}</div>
          <div className="ref-stat-label">{t("rewards.invited")}</div>
        </div>

        <div className="ref-stat-card ref-compact-card">
          <div className="ref-stat-icon-wrapper ref-stat-green">
            <FaCheckDouble className="ref-stat-icon" />
          </div>
          <div className="ref-stat-value">{summary?.qualifiedCount || 0}</div>
          <div className="ref-stat-label">{t("rewards.qualified")}</div>
        </div>

        <div className="ref-stat-card ref-compact-card">
          <div className="ref-stat-icon-wrapper ref-stat-yellow">
            <FaCoins className="ref-stat-icon" />
          </div>
          <div className="ref-stat-value">
            {(summary?.totalEarned || 0).toLocaleString()} TK
          </div>
          <div className="ref-stat-label">{t("rewards.totalEarned")}</div>
        </div>
      </div>

      {/* How it works */}
      <div className="ref-how-card ref-compact-card">
        <h3 className="ref-section-title">
          <FaLightbulb className="ref-section-icon" />
          {t("rewards.howTitle")}
        </h3>

        <div className="ref-steps-grid">
          <div className="ref-step-item">
            <div className="ref-step-number">1</div>
            <h4 className="ref-step-title">{t("rewards.step1Title")}</h4>
            <p className="ref-step-desc">{t("rewards.step1")}</p>
          </div>

          <div className="ref-step-item">
            <div className="ref-step-number ref-step-number-purple">2</div>
            <h4 className="ref-step-title">{t("rewards.step2Title")}</h4>
            <p className="ref-step-desc">{t("rewards.step2")}</p>
          </div>

          <div className="ref-step-item">
            <div className="ref-step-number ref-step-number-green">3</div>
            <h4 className="ref-step-title">{t("rewards.step3Title")}</h4>
            <p className="ref-step-desc">{t("rewards.step3")}</p>
          </div>
        </div>
      </div>

     {/* Rules / Note */}
    <div className="ref-rules-note">
    <div className="ref-rules-title">{t("rewards.rulesTitle")}</div>
    <ul className="ref-rules-list">
        <li>{t("rewards.ruleApproved")}</li>
        <li>{t("rewards.ruleMinRecharge")}</li>
        <li className="ref-strong">{t("rewards.ruleBonus")}</li>
    </ul>
    </div>

      {/* Apply Code CTA */}
      {canApply && (
        <div className="ref-apply-compact-card ref-compact-card">
          <div className="ref-apply-compact-content">
            <FaTicketAlt className="ref-apply-compact-icon" />
            <div className="ref-apply-compact-text">
              <h4 className="ref-apply-compact-title">{t("rewards.applyCtaTitle")}</h4>
              <p className="ref-apply-compact-subtitle">
                {t("rewards.applyCtaSubtitle")}
              </p>
            </div>
          </div>
          <button
            className="ref-apply-compact-btn"
            onClick={() => setShowApplyModal(true)}
          >
            {t("rewards.applyCtaButton")}
          </button>
        </div>
      )}

      {/* History */}
      {summary?.recent && summary.recent.length > 0 && (
        <div className="ref-history-card ref-compact-card">
          <h3 className="ref-section-title">
            <FaHistory className="ref-section-icon" />
            {t("rewards.historyTitle")}
          </h3>

          <div className="ref-history-list">
            {summary.recent.map((r) => {
              const peer = r.peer;
              const avatar = peer?.image
                ? `${URL}/uploads/${peer.image}`
                : "https://i.pravatar.cc/80?img=15";
              return (
                <div key={r.Id} className="ref-history-item">
                  <div className="ref-history-left">
                    <img
                      className="ref-history-avatar"
                      src={avatar}
                      alt={peer?.fullName || "User"}
                    />
                    <div className="ref-history-info">
                      <h4 className="ref-history-name">
                        {peer?.fullName || t("rewards.unknown")}
                      </h4>
                      <p className="ref-history-feedback">{r.feedback}</p>
                      <p className="ref-history-date">
                        {/* {new Date(r.transactionDate).toLocaleDateString()} */}
                        {formatLongDMY(r.transactionDate)}
                      </p>
                    </div>
                  </div>
                  <div className="ref-history-amount">+{r.netAmount} TK</div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Already Applied Notice */}
      {!canApply && (
        <div className="ref-already-applied ref-compact-card">
          <FaCheck className="ref-already-applied-icon" />
          <div className="ref-already-applied-text">
            {summary?.applicant?.hasApplied
              ? t("rewards.alreadyApplied")
              : t("rewards.notEligible")}
          </div>
        </div>
      )}

      {/* Back button */}
      <div className="ref-topbar">
        <button className="ref-back" onClick={() => navigate(-1)}>
          <FaArrowLeft /> {t("commonthing.goBack")}
        </button>
      </div>

      {/* Apply Code Modal */}
      {showApplyModal && (
        <div
          className="ref-modal-overlay"
          onClick={() => setShowApplyModal(false)}
        >
          <div
            className="ref-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="ref-modal-header">
              <h2 className="ref-modal-title">
                <FaTicketAlt className="ref-modal-title-icon" />
                {t("modal.title")}
              </h2>
              <button
                className="ref-modal-close"
                onClick={() => setShowApplyModal(false)}
              >
                ✕
              </button>
            </div>

            <div className="ref-modal-body">
              <div className="ref-modal-info-box">
                <div className="ref-modal-info-icon">
                  <FaGift />
                </div>
                <div className="ref-modal-info-text">
                  <h3 className="ref-modal-info-title">{t("modal.offerTitle")}</h3>
                  <p className="ref-modal-info-desc">{t("modal.offerDesc")}</p>
                </div>
              </div>

              <form className="ref-modal-form" onSubmit={handleApply}>
                <div className="ref-modal-input-group">
                  <label className="ref-modal-label">{t("modal.label")}</label>
                  <input
                    type="text"
                    className="ref-modal-input"
                    placeholder={t("modal.placeholder")}
                    value={applyCode}
                    onChange={(e) => setApplyCode(e.target.value.toUpperCase())}
                    maxLength={24}
                    required
                  />
                  {error && <div className="ref-modal-error">{error}</div>}
                  {applyMsg && (
                    <div className="ref-modal-success">
                      <FaCheck /> {applyMsg}
                    </div>
                  )}
                </div>

                <button
                  type="submit"
                  className="ref-modal-submit-btn"
                  disabled={applying}
                >
                  {applying ? t("modal.submitting") : t("modal.submit")}
                </button>
              </form>

              <div className="ref-modal-terms">
                <h4 className="ref-modal-terms-title">{t("modal.termsTitle")}</h4>
                <ul className="ref-modal-terms-list">
                  <li>
                    <FaCheck className="ref-modal-terms-icon" />
                    <span>{t("modal.t1")}</span>
                  </li>
                  <li>
                    <FaCheck className="ref-modal-terms-icon" />
                    <span>{t("modal.t2")}</span>
                  </li>
                  <li>
                    <FaCheck className="ref-modal-terms-icon" />
                    <span>{t("modal.t3")}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServitorReferralRewards;
